module.exports = __webpack_public_path__ + "img/other_pay_pi.2f0fab76.svg";